import { Link } from "react-router-dom"
import "./footer.scss"
import logo from "../../../assets/images/footer/footerLogo.png"
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useDispatch } from "react-redux";
import { openContactUsModal } from "../../../redux/ContactUsModalSlice";

const FooterLogo = () => (
  <div className="footerLogoBox">
    <div className="footerLogo">
      <img src={logo} alt="logo" />
      <h1>GenieGig</h1>
    </div>
    <p>© PlatinumSpark Technologies Pvt Ltd 2025</p>
  </div>
);

const FooterLinks = () => (
  <div className="footerLinksBox">
    <div className="footer-col col-1">
      <div className="head">About Us</div>
      <ul>
        <li><Link to={"/about"}>Learn about us</Link></li>
      </ul>
    </div>
    <div className="footer-col col-2">
      <div className="head">Our Policies</div>
      <ul>
        <li><Link to={"/terms-of-service"} target="_blank" rel="noopener noreferrer">Terms of Service</Link></li>
        <li><Link to={"/privacy-policy"} target="_blank" rel="noopener noreferrer">Privacy Policy</Link></li>
      </ul>
    </div>
    <div className="footer-col col-3">
      <div className="head">FAQs</div>
      <ul>
        <li><Link to={"/FAQs"}>Browse All FAQs</Link></li>
      </ul>
    </div>
  </div>
);

const FooterReachUs = ({ onContactClick }: { onContactClick: (e: React.MouseEvent) => void }) => (
  <div className="footer-col col-reach-us">
    <div className="head">Reach Us</div>
    <ul>
      <li><div style={{fontWeight: '500'}}>PlatinumSpark Technologies Pvt Ltd</div></li>
      <li><div>Email: info@geniegig.com</div></li>
      <li><div>Telephone: +91-8368857097</div></li>
      <li><Link to="#" onClick={onContactClick}><u>Contact Us</u></Link></li>
    </ul>
  </div>
);

const FooterSocials = () => (
  <div className="footer-col col-connect-us">
    <div className="head">Connect With Us</div>
    <div className="social-icons">
      <Link to="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><InstagramIcon className="social-icon"/></Link>
      <Link to="https://www.youtube.com/" target="_blank" rel="noopener noreferrer"><YouTubeIcon className="social-icon"/></Link>
      <Link to="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><LinkedInIcon className="social-icon"/></Link>
    </div>
  </div>
);

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const dispatch = useDispatch();

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(openContactUsModal());
  };

  return (
    <section className={`footer ${className || ''}`}>
      <div className="footerBottom">
        <div className="footerTopSection">
          <FooterLogo />
          <FooterLinks />
        </div>
        <div className="footerSeparator"></div>
        <div className="footerBottomSection">
          <FooterReachUs onContactClick={handleContactClick} />
          <FooterSocials />
        </div>
      </div>
    </section>
  )
}

export default Footer;